import React from 'react'
import recordIcon1 from '@/assets/szyjxy/record-1.svg'
import recordIcon2 from '@/assets/szyjxy/record-2.svg'
import recordIcon3 from '@/assets/szyjxy/record-3.svg'
import { ProjectConfig } from '@/project-config'
import icPhoneActive from '../../assets/login/phone-active.svg'
import icCodeActive from '../../assets/login/code-active.svg'
import icPsdActive from '../../assets/login/psd-active.svg'
import LoginLeft from '../login/components/login-left'
import LoginRight from '../login/components/login-right'
import lessModule from './index.module.less'

const preloadImg = (src: string) => {
  const img = new Image()
  img.src = src
}
preloadImg(icPhoneActive)
preloadImg(icCodeActive)
preloadImg(icPsdActive)

export default function SuzhouLogin() {
  return (
    <div className={`${lessModule.login} login-custom-form`} id="login-form-override">
      <div className={lessModule.loginLeft}>
        <LoginLeft hideProductName />
      </div>
      <LoginRight disableAnimation titleText={ProjectConfig.loginRight.titleText} />
      <div className={lessModule.footer}>
        <span>主办单位：苏州工业园区教育局</span>
        <i />
        <span>苏ICP备案号：06048641</span>
        <span>网站标志码3205900024</span>
        <img src={recordIcon1} alt="" />
        <i />
        <span>苏公网安备:32059002001771号</span>
        <img src={recordIcon2} alt="" />
        <img src={recordIcon3} alt="" />
        <i />
        <span>技术支持单位：北京飞象星球科技有限公司</span>
      </div>
    </div>
  )
}
